(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scent-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeQuiz = (quiz) => {
      if (quiz.dataset.initialized === 'true') return;
      quiz.dataset.initialized = 'true';

      const totalQuestionSteps = 6;
      const totalSteps = 8;
      const answers = {
        families: [],
        naturalNotes: '',
        personalStyle: '',
        wearOccasion: '',
        projection: '',
        moodOrMemory: '',
        email: '',
      };
      const steps = Array.from(quiz.querySelectorAll('[data-step]'));
      const progressArea = quiz.querySelector('.scent-quiz__progress-area');
      const progressTrack = quiz.querySelector('[data-progress-track]');
      const progressBar = quiz.querySelector('[data-progress-bar]');
      const stepLabel = quiz.querySelector('[data-step-label]');
      const encouragement = quiz.querySelector('[data-encouragement]');
      const openAnswer = quiz.querySelector('[data-open-answer]');
      const emailInput = quiz.querySelector('[data-email]');
      const continueButton = quiz.querySelector('[data-continue]');
      const resultsLoading = quiz.querySelector('[data-results-loading]');
      const resultsContent = quiz.querySelector('[data-results-content]');
      const resultEmail = quiz.querySelector('[data-result-email]');
      const productGrid = quiz.querySelector('[data-product-grid]');
      const resultProducts = Array.from(quiz.querySelectorAll('[data-result-product]'));
      const customerForm = quiz.querySelector('.scent-quiz__customer-form');
      const customerFormSuccess = quiz.querySelector('[data-customer-form-success]');
      const customerFormErrors = quiz.querySelector('[data-customer-form-errors]');
      let currentStep = 1;
      let advanceTimer;
      let transitionTimer;

      for (let index = resultProducts.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [resultProducts[index], resultProducts[randomIndex]] = [resultProducts[randomIndex], resultProducts[index]];
      }

      resultProducts.slice(0, 3).forEach((product) => {
        product.hidden = false;
        productGrid.appendChild(product);
      });

      const updateProgress = () => {
        const progressStep = Math.min(currentStep, totalQuestionSteps);
        stepLabel.textContent = currentStep > totalQuestionSteps ? 'Questions complete' : `Step ${currentStep} of ${totalQuestionSteps}`;
        progressBar.style.width = `${(progressStep / totalQuestionSteps) * 100}%`;
        progressTrack.setAttribute('aria-valuenow', String(progressStep));
        encouragement.textContent = currentStep > totalQuestionSteps ? 'Final step' : currentStep >= 5 ? 'Almost there' : '';
      };

      const showStep = (nextStep) => {
        if (nextStep < 1 || nextStep > totalSteps || nextStep === currentStep) return;
        window.clearTimeout(advanceTimer);
        window.clearTimeout(transitionTimer);

        const outgoing = steps[currentStep - 1];
        const incoming = steps[nextStep - 1];
        outgoing.classList.add('is-leaving');

        transitionTimer = window.setTimeout(() => {
          outgoing.hidden = true;
          outgoing.classList.remove('is-active', 'is-leaving');
          incoming.hidden = false;
          incoming.classList.add('is-active');
          currentStep = nextStep;
          updateProgress();
          incoming.querySelector('[data-back], .scent-quiz__option, textarea, input')?.focus({ preventScroll: true });
        }, 180);
      };

      quiz.querySelectorAll('[data-selection="multiple"] .scent-quiz__option').forEach((option) => {
        option.addEventListener('click', () => {
          const value = option.dataset.value;
          const isSelected = option.classList.toggle('is-selected');
          option.setAttribute('aria-pressed', String(isSelected));

          if (isSelected) {
            answers.families.push(value);
          } else {
            answers.families = answers.families.filter((answer) => answer !== value);
          }
        });
      });

      quiz.querySelectorAll('[data-selection="single"] .scent-quiz__option').forEach((option) => {
        option.addEventListener('click', () => {
          const group = option.closest('[data-answer]');
          const answerKey = group.dataset.answer;

          group.querySelectorAll('.scent-quiz__option').forEach((groupOption) => {
            const isSelected = groupOption === option;
            groupOption.classList.toggle('is-selected', isSelected);
            groupOption.setAttribute('aria-pressed', String(isSelected));
          });

          answers[answerKey] = option.dataset.value;
          window.clearTimeout(advanceTimer);
          advanceTimer = window.setTimeout(() => showStep(currentStep + 1), 350);
        });
      });

      quiz.querySelector('[data-next]').addEventListener('click', () => showStep(2));

      quiz.querySelectorAll('[data-back]').forEach((backButton) => {
        backButton.addEventListener('click', () => showStep(currentStep - 1));
      });

      const showEmailStep = (skipOpenAnswer) => {
        answers.moodOrMemory = skipOpenAnswer ? '' : openAnswer.value.trim();
        showStep(7);
      };

      const isEmailValid = () => emailInput.value.trim() !== '' && emailInput.validity.valid;

      emailInput.addEventListener('input', () => {
        continueButton.disabled = !isEmailValid();
      });

      customerForm.addEventListener('submit', (event) => {
        if (!isEmailValid()) {
          event.preventDefault();
          return;
        }

        answers.email = emailInput.value.trim();
        console.log('Scent quiz answers:', { ...answers, families: [...answers.families] });
      });

      const showInitialPostState = () => {
        if (!customerFormSuccess && !customerFormErrors) return;

        steps.forEach((step) => {
          step.hidden = true;
          step.classList.remove('is-active', 'is-leaving');
        });

        if (customerFormSuccess) {
          currentStep = 8;
          steps[7].hidden = false;
          steps[7].classList.add('is-active');
          resultsLoading.hidden = true;
          resultsContent.hidden = false;
          resultEmail.textContent = customerFormSuccess.dataset.email || emailInput.value.trim();
        } else {
          currentStep = 7;
          steps[6].hidden = false;
          steps[6].classList.add('is-active');
          continueButton.disabled = !isEmailValid();
        }
      };

      quiz.querySelector('[data-submit]').addEventListener('click', () => showEmailStep(false));
      quiz.querySelector('[data-skip]').addEventListener('click', () => showEmailStep(true));

      showInitialPostState();
      updateProgress();
    };

    const initializeAllQuizzes = (root = document) => {
      root.querySelectorAll('[data-scent-quiz]').forEach(initializeQuiz);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAllQuizzes(), { once: true });
    } else {
      initializeAllQuizzes();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAllQuizzes(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-feature"] && !Shopify.designMode) return;
  try {
    
  const initializeStoryFeatureReveals = (root = document) => {
    const sections = root.querySelectorAll('.story-feature:not(.story-feature--reveal-ready)');

    if (!sections.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      sections.forEach((section) => section.classList.add('story-feature--revealed'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('story-feature--revealed');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
    );

    sections.forEach((section) => {
      section.classList.add('story-feature--reveal-ready');
      observer.observe(section);
    });
  };

  initializeStoryFeatureReveals();
  document.addEventListener('shopify:section:load', (event) => initializeStoryFeatureReveals(event.target));

  } catch(e) { console.error(e); }
})();
})();
